(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/store/assets/reducers/races-reducer.js') >= 0) return;  svs.modules.push('/components/marketplace-data/store/assets/reducers/races-reducer.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _svs$components$marke = svs.components.marketplaceData.draws.actions,
  FETCH_SINGLE_DRAW_SUCCESS = _svs$components$marke.FETCH_SINGLE_DRAW_SUCCESS,
  FETCH_PRODUCTS_DRAWS_SUCCESS = _svs$components$marke.FETCH_PRODUCTS_DRAWS_SUCCESS,
  FETCH_ALL_DRAWS_SUCCESS = _svs$components$marke.FETCH_ALL_DRAWS_SUCCESS;
const _svs$components$lbUti = svs.components.lbUtils.sportProducts,
  productIds = _svs$components$lbUti.productIds,
  getProdName = _svs$components$lbUti.getProdName;
const racesReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case FETCH_SINGLE_DRAW_SUCCESS:
    case FETCH_PRODUCTS_DRAWS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), Object.keys(action.races || {}).reduce((obj, prop) => _objectSpread(_objectSpread({}, obj), {}, {
        [prop]: _objectSpread(_objectSpread({}, state[prop]), action.races[prop])
      }), {}));
    case FETCH_ALL_DRAWS_SUCCESS:
      if (!action.productDraws[getProdName(productIds.RACING)]) {
        return state;
      }
      return _objectSpread(_objectSpread({}, state), action.productDraws[getProdName(productIds.RACING)].races);
    default:
      return state;
  }
};
setGlobal('svs.components.marketplaceData.store.reducers.racesReducer', racesReducer);

 })(window);